//export const URL_API_AGP = "https://localhost:7126";  // https://localhost:7126
export const URL_PATH_MEDIA_APG = "https://agropraxisgroup.cl/upload/";

export const URL_API_AGP = "https://service.agropraxisgroup.cl"; 

